module.exports = __webpack_public_path__ + "static/media/3.d7d35a2b.png";